import React from 'react'
import Footer from '../Footer/Footer'
import Image from '../../../assets/landing-tshirt.png'
import MobileImage from '../../../assets/landing-mobile-shirt.png'
import {
    Container,
    CopyContent,
    Copy,
    MobileCopy,
    Text,
    ImgContainer,
    Button,
} from './Elements'
import {
    copyMotion,
    textMotion,
    buttonMotion,
    imgMotion,
} from './Motion'

const Onboarding = () => {

    return(
        <Container>
            <CopyContent>
                <Copy
                key='copy'
                variants={copyMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                >
                    Personalizamos prendas
                </Copy>
                <MobileCopy
                key='copy'
                variants={copyMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                >
                    Persona-<br></br>
                    lizamos<br></br> 
                    prendas
                </MobileCopy>
                <Text
                key='text'
                variants={textMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                >
                    Dale la identidad de tu empresa a cada prenda.
                </Text>
                <Button 
                key='button'
                variants={buttonMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                to='/tecnica'
                >
                    Calculá tu presupuesto
                </Button>
            </CopyContent>
            <ImgContainer
            key='image'
            variants={imgMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                <source media="(min-width: 651px)" srcSet={Image} />
                <source media="(max-width: 650px)" srcSet={MobileImage} />
                <img src={Image} alt="shirt image" />
            </ImgContainer>
            <Footer />
        </Container>
    )
}

export default Onboarding